import { createSlice } from "@reduxjs/toolkit";
import { BestPlayerEntity, SeasonsForMvp, VotingMatch } from "common/interfaces/bestPlayer";
import { Player } from "common/interfaces/players";
import { Team } from "common/interfaces/teams";
import {
  getBestPlayer,
  getBestPlayerList,
  getMainTeamPlayers,
  getSeasonForMvp,
  getVotingMatches,
  getVotingTeams,
} from "store/bestPlayer/bestPlayerActionAsync";

export type BestPlayerState = {
  isLoading: boolean;
  count: number;
  items?: BestPlayerEntity[];
  entity?: BestPlayerEntity;
  mainTeamPlayers: Player[];
  matches: VotingMatch[];
  seasons: SeasonsForMvp[];
  teams: Team[];
};

export const bestPlayerInitialState: BestPlayerState = {
  isLoading: false,
  count: 0,
  mainTeamPlayers: [],
  matches: [],
  seasons: [],
  teams: [],
};

export const { actions: bestPlayerActions, reducer: bestPlayerReducer } = createSlice({
  name: "bestPlayer",
  initialState: bestPlayerInitialState,
  reducers: {
    resetEntity(state) {
      state.entity = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBestPlayerList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBestPlayerList.fulfilled, (state, { payload }) => {
        state.count = payload.count;
        state.items = payload.items;
        state.isLoading = false;
      })
      .addCase(getBestPlayerList.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getBestPlayer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBestPlayer.fulfilled, (state, { payload }) => {
        state.entity = payload;
        state.isLoading = false;
      })
      .addCase(getBestPlayer.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getMainTeamPlayers.fulfilled, (state, { payload }) => {
        state.mainTeamPlayers = payload;
        state.isLoading = false;
      })
      .addCase(getMainTeamPlayers.pending, (state) => {
        state.isLoading = true;
      })

      .addCase(getVotingMatches.fulfilled, (state, { payload }) => {
        state.matches = payload;
        state.isLoading = false;
      })

      .addCase(getSeasonForMvp.fulfilled, (state, { payload }) => {
        state.seasons = payload;
        state.isLoading = false;
      })
      .addCase(getVotingTeams.fulfilled, (state, { payload }) => {
        state.teams = payload;
        state.isLoading = false;
      });
  },
});
